import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import heCommon from "./locales/he/common.json";
// import ruCommon from "./locales/ru/common.json"; // Russian locale disabled

const resources = {
  he: {
    common: heCommon,
  },
  // ru: {
  //   common: ruCommon,
  // },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "he", // Default language is Hebrew
  fallbackLng: "he", // Fallback to Hebrew
  defaultNS: "common",
  ns: ["common"],

  interpolation: {
    escapeValue: false, // React already escapes values
  },

  // Use flat keys only, no nested separators
  keySeparator: false,
  nsSeparator: false,

  debug: process.env.NODE_ENV === "development",
});

export default i18n;
